import React, { useState } from 'react';
import { formatInTimeZone } from 'date-fns-tz';
import { useRootSelector } from '../../../../../../../store/hooks';
import { transformStringToPath } from '../../../../../../../helpers/transformStringToPath';
import { selectPageConfig } from '../../../../../../../store/features/pageConfig';
import s from './ScheduleItem.module.scss';
import GuestPhoto from '../../GuestPhoto';
import Arrow from './Arrow';
import { Anchor } from '../../../../../../shared/Anchor';

const productTypeMap = {
  PHOTOOP: 'Photo Op',
  AT_TABLE: 'At Table',
};

export default function ScheduleItem({ data, guest }) {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const { sitePath } = useRootSelector(selectPageConfig);

  const time = formatInTimeZone(new Date(data.startDate), 'UTC', 'h:mm aaa');
  const product = productTypeMap[data.productType] ?? data.productType;
  const location = [time, 'in', product, data.location]
    .filter(Boolean)
    .join(' ');
  const showDropdown =
    Boolean(data.description) || data.organisations.length > 0;

  return (
    <div className={s.wrapper}>
      <div className={s.header}>
        <div className={s.time}>{time}</div>
      </div>
      <div className={s.body}>
        {data.image && (
          <div className={s.aside}>
            <GuestPhoto src={data.image} alt={data.imageAlt} />
          </div>
        )}
        {!data.image && guest?.images[guest.category] && (
          <div className={s.aside}>
            <GuestPhoto
              src={guest.images[guest.category]}
              alt={guest.imageAlt}
            />
          </div>
        )}
        <div className={s.content}>
          <div
            onClick={() => {
              if (showDropdown) {
                setDropdownOpen((open) => !open);
              }
            }}
            className={s.top}
            role={showDropdown ? 'button' : undefined}
          >
            {data.title && <div className={s.title}>{data.title}</div>}
            {showDropdown && <Arrow open={dropdownOpen} />}
          </div>
          {(data.productType || data.location) && (
            <div className={s.location}>{location}</div>
          )}
          {dropdownOpen && (
            <div className={s.dropdown}>
              {data.description && (
                <div className={s.description}>{data.description}</div>
              )}
              {data.organisations.map((organisation) => {
                const name = transformStringToPath(organisation.name);
                const url = `/our-guests/${name}/${organisation.id}/`;

                return (
                  <Anchor
                    to={url}
                    pathPrefix={sitePath}
                    className={s.organisation}
                    key={organisation.id}
                  >
                    {organisation.name}
                  </Anchor>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
